import React from "react";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import loaderImage from "../../../static/loader.gif";

export default class ImportStudent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            file: null,
            loading: false,
            show_logic_info: false,
            notification_errors: {},
            notification_imports: {}
        };
    }

    fileUpload = (e) => {
        e.preventDefault();
        const url = `/v1/courses/${this.props.course.uuid}/import/`;

        if (this.state.file) {
            const formData = new FormData();
            formData.append("file", this.state.file);

            this.setState({
                loading: true
            });

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Content-Disposition": `attachment; filename="${this.state.file.name}"`
                }
            };
            axios({
                method: "post",
                url: url,
                data: formData,
                timeout: 5 * 60 * 1000
            })
                .then((response) => {
                    this.setState({
                        file: null,
                        loading: false,
                        notification_errors: response.data.errors,
                        notification_imports: response.data.imported
                    });
                    this.refs.file.value = null;
                    this.props.refreshData();
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    handleFileChange = (e) => {
        this.setState({
            [e.target.name]: e.target.files[0],
            notification_errors: {},
            notification_imports: {}
        });
    };

    render = () => {
        if (!this.props.course) {
            return null;
        }

        let notifications = [];
        let errors = [];
        let imports = [];

        // Check if we have errors
        for (let [key, value] of Object.entries(this.state.notification_errors)) {
            errors.push(
                <div key={key}>
                    Regel {key}: {value.message}
                </div>
            );
        }
        // Check if we have successful imports
        for (let [key, value] of Object.entries(this.state.notification_imports)) {
            imports.push(
                <div key={key}>
                    Regel {key}: {value.full_name} is succesvol toegevoegd ({value.nibhv_number})
                </div>
            );
        }

        if (errors.length > 0) {
            notifications.push(
                <div className="alert alert-danger" key="errors">
                    {errors}
                </div>
            );
        }
        if (imports.length > 0) {
            notifications.push(
                <div className="alert alert-success" key="imports">
                    {imports}
                </div>
            );
        }

        let fileForm = (
            <div>
                <strong>Het bestand wordt geimporteerd...</strong>
                <br />
                <img src={loaderImage} alt="Loading" />
            </div>
        );
        if (this.state.loading === false) {
            fileForm = (
                <form>
                    <div className="form-group">
                        <input type="file" name="file" className="form-control-file mb-3" ref="file" onChange={this.handleFileChange} />
                        <button className="btn btn-primary" onClick={(e) => this.fileUpload(e)}>
                            Bestand importeren
                        </button>
                    </div>
                </form>
            );
        }

        return (
            <div>
                <h2>
                    Cursisten importeren &nbsp;
                    <i className="fa fa-info-circle pointer" data-tip data-for={"tip-import-info"} onClick={(e) => e.stopPropagation()}></i>
                    <ReactTooltip id={"tip-import-info"} effect="solid" place="left">
                        <p>Om de cursushistorie te behouden, zijn de volgende importregels van belang:</p>
                        <ul>
                            <li>Als er een oud NIBHV nummer is ingevuld wordt dit gebruikt om te matchen.</li>
                            <li>Als het oude NIBHV nummer leeg is maar er is een nieuw NIBHV nummer ingevoerd gebruiken we dat om te matchen.</li>
                            <li>Als beiden leeg zijn gebruiken we de combinatie van e-mail en Geboortedatum om een match te maken.</li>
                            <li>
                                Als het e-mailadres en geboortedatum geen match opleverde dan maken we een nieuwe gebruiker aan, mits het e-mailadres niet reeds in
                                gebruik is.
                            </li>
                            <li>Als er nieuwe gebruikers aangemaakt zijn dan rapporteren we dat terug na de import.</li>
                            <li>
                                Als er geen match gemaakt heeft kunnen worden dan rapporteren we dat terug na de import. Bijvoorbeeld, als er een gebruiker met dezelfde
                                achternaam en geboortedatum is dan melden we dat en importeren deze niet. Je kunt dan zelf controleren of dit de juiste gebruiker is en
                                deze handmatig toevoegen.
                            </li>
                        </ul>
                    </ReactTooltip>
                </h2>
                <p>
                    <a href="/import-kandidatenlijst-cursus.xltx" target="_blank">
                        Download de template voor Excel
                    </a>{" "}
                    om deze in te vullen en te importeren.
                </p>

                {notifications}

                {fileForm}
            </div>
        );
    };
}
